import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'
import memberList from './mock/members.json'
import { companies, businessunits } from './mock/organizations.json'
import orgData from '@/api/manager/menu/mock/org.json'

// 조직 구성원 정보 가져오기
export function getUserList(retrieveData) {
  if (isUseAPI()) {
    let params = { company: '', bsns_cd: '', dept_cd: '', user_id: '', user_nm: '', asgn_shrt_nm: '', asgn_cd: '' }
    if (retrieveData.company) params.company = retrieveData.company
    if (retrieveData.dept_cd) params.dept_cd = retrieveData.dept_cd
    if (retrieveData.asgn_cd) params.dept_cd = retrieveData.asgn_cd
    if (retrieveData.kor_nm) params.user_nm = retrieveData.kor_nm
    if (retrieveData.user_id) params.user_id = retrieveData.user_id
    if (retrieveData.bsns_cd) params.bsns_cd = retrieveData.bsns_cd
    if (retrieveData.asgn_shrt_nm) params.asgn_shrt_nm = retrieveData.asgn_shrt_nm
    if ((!params.company) && (!params.dept_cd) && (!params.user_nm) && (!params.user_id) && (!params.bsns_cd)) {
      return
    }
    return request({
      url: '/hiway/members',
      method: 'get',
      meta: { apiVersion: '2.0.0' },
      params
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(memberList)
  })
}
// 회사 내의 모든 조직을 트리구조로 가져오기
export function getAllOrganizationTreeList(params) {
  if (isUseAPI()) {
    // let params = { company: '', asgn_cd: '', bsns_cd: '', dept_cd: '', prnt_cd: '', clss_cd: '' }
    // if (retrieveData.company) params.company = retrieveData.company
    // if (retrieveData.dept_cd) params.dept_cd = retrieveData.dept_cd
    // if (retrieveData.kor_nm) params.asgn_cd = retrieveData.kor_nm
    // if (retrieveData.user_id) params.user_id = retrieveData.user_id
    // if (retrieveData.bsns_cd) params.bsns_cd = retrieveData.bsns_cd
    // if (retrieveData.bsns_cd) params.bsns_cd = retrieveData.bsns_cd
    if (!params.company) {
      return
    }
    return request({
      url: '/hiway/organizations/company/' + params.company,
      method: 'get',
      meta: { apiVersion: '2.0.0' },
      params
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(_.cloneDeep(orgData))
  })
}

// 사업부에 속하는 부서정보 가져오기
export function getDepartments(params) {
  if (isUseAPI()) {
    if ((!params.company) && (!params.bsns_cd)) {
      return
    }
    return request({
      url: '/hiway/organizations/departmentsinbu/company/' + params.company + '/bu/' + params.bsns_cd,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(memberList)
  })
}
export function getAllBusinessUnits(params) {
  if (isUseAPI()) {
    return request({
      url: '/hiway/organizations/businessunits',
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(businessunits)
  })
}
export function getBusinessUnits(params) {
  if (isUseAPI()) {
    return request({
      url: '/hiway/organizations/businessunits/company/' + params.company,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(businessunits)
  })
}
export function getCompanies() {
  if (isUseAPI()) {
    return request({
      url: '/hiway/organizations/companies',
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(companies)
  })
}
